import normalizeComponent from "../../../_virtual/_plugin-vue2_normalizer.mjs";
const _sfc_main = {};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  return _c("svg", { attrs: { "width": "16", "height": "16", "viewBox": "0 0 16 16", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, [_c("path", { staticStyle: { "fill": "color(display-p3 0.3098 0.3451 0.4196)", "fill-opacity": "1" }, attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", "d": "M7.66675 1.2337L15.7018 8L7.66675 14.7663V10.6155C4.87045 10.7492 2.95122 11.7487 1.54259 13.7208L0.346375 13.2026C0.695334 11.4578 1.40055 9.6728 2.66505 8.22766C3.8396 6.88533 5.47132 5.86629 7.66675 5.43668L7.66675 1.2337ZM9.00009 4.09963V6.5782L8.42769 6.65996C6.24805 6.97133 4.72737 7.89553 3.66848 9.10566C3.19948 9.64166 2.81533 10.2406 2.50503 10.8783C4.06386 9.77713 5.98581 9.26666 8.33342 9.26666H9.00009V11.9004L13.6318 8L9.00009 4.09963Z", "fill": "#4F586B" } })]);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  null
);
const ShareIcon = __component__.exports;
export {
  ShareIcon as default
};
